import { useEffect, useMemo, useState } from 'react';

import { Layout, Menu, type MenuProps } from 'antd';
import { Link, useLocation } from 'react-router';

import { ENVS, EUserRole, ROUTES } from '@/shared/consts';
import { useUserProfile } from '@/shared/hooks';

import { getSidebarItem } from './helpers';
import styles from './Sidebar.module.scss';

export const Sidebar = () => {
  const location = useLocation();

  const { userProfile } = useUserProfile();

  const [selectedMenuItem, setSelectedMenuItem] = useState<string[]>([location.pathname]);

  const isAdminRole = userProfile.roles[0] === EUserRole.Admin;

  const items: MenuProps['items'] = useMemo(
    () => [
      {
        label: 'Публичные страницы',
        type: 'group',
        children: [
          isAdminRole ? getSidebarItem('Главная', `${ROUTES.PUBLIC_PAGES}/${ROUTES.MAIN}`) : null,
          getSidebarItem('Школы', `${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`),
        ],
      },
    ],
    [isAdminRole],
  );

  useEffect(() => {
    setSelectedMenuItem([location.pathname]);
  }, [location.pathname]);

  return (
    <Layout.Sider width={280}>
      <div className={styles['logos-wrapper']}>
        <Link to={ENVS.PUBLIC_PSB_URL}>
          <img
            src="/images/logotypes/psb_logo.svg"
            alt="Лого ПСБ"
          />
        </Link>
        <div className={styles['logos-divider']} />
        <Link to="/">
          <img
            src="/images/logotypes/dep_logo.svg"
            alt="Лого Школы Цифровых Ролей"
          />
        </Link>
      </div>
      <Menu
        items={items}
        selectedKeys={selectedMenuItem}
        mode="inline"
        theme="dark"
        className={styles.menu}
      />
    </Layout.Sider>
  );
};
